/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha Dhanireddy <snigdha.dhanireddy@mroads.com>, Jul 2023
 * @flow
 */


import React from 'react';
import { Box, Typography } from '@material-ui/core';
import useStyles from './useStyles';

const TextInput = (props) => {
  const { type, placeholder, value, onChange, inputStyle, disabled, labelStyle } = props;

  const classes = useStyles();
  return (
    <Box className={classes.container}>
      <Typography className={[classes.label, labelStyle].join(' ')}>{placeholder}</Typography>
      <input type={type} value={value} onChange={event => onChange(event.target.value)} className={inputStyle} disabled={disabled} />
    </Box>
  );
};

export default TextInput;